import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { buscarUnidad } from "../api/General";
import { isInvalid } from "../utils/forms";
import { crearResiduoPatogenico } from "../utils/data";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextField from "./controls/TextField";
import ArrayField from "./controls/ArrayField";
import { ResiduoPatogenicoForm } from "./ResiduoPagotenicoForm";
import { ResiduoPatogenicoList } from "./ResiduoPatogenicoList";

export default function ResiduosPatogenicosForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const unidadCantidadCatalog = useCatalog(["unidad", "KG"], () =>
    buscarUnidad("KG"),
  );
  const loading = unidadCantidadCatalog.loading;
  const handleRegistroResiduosPatogenicosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleResiduosPatogenicosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={4}>
            <TextField
              id="registroResiduosPatogenicos"
              name="registroResiduosPatogenicos"
              label={t("tramite.registroResiduosPatogenicos")}
              value={tramiteForm.values?.registroResiduosPatogenicos}
              onChange={handleRegistroResiduosPatogenicosChange}
              labelStyle={{ whiteSpace: "nowrap" }}
              isInvalid={isInvalid("registroResiduosPatogenicos", tramiteForm)}
              error={t(tramiteForm.errors.registroResiduosPatogenicos)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="residuosPatogenicos"
              name="residuosPatogenicos"
              label={t("tramite.residuosPatogenicos")}
              value={tramiteForm.values?.residuosPatogenicos}
              onChange={handleResiduosPatogenicosChange}
              createItem={crearResiduoPatogenico}
              isInvalid={isInvalid("residuosPatogenicos", tramiteForm)}
              error={
                (tramiteForm.errors.residuosPatogenicos instanceof Array &&
                  t("errors.tramite.residuosPatogenicos.many")) ||
                t(tramiteForm.errors.residuosPatogenicos)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: residuosPatogenicos,
                append,
                remove,
                replace,
                select,
                selectedItem,
                selectedIndex,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <ResiduoPatogenicoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={residuosPatogenicos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          unidadCantidad={unidadCantidadCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <ResiduoPatogenicoList
                        value={residuosPatogenicos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
